
import { defineComponent, PropType } from 'vue';
import Button from '@/models/ButtonModel';

import RefButton from './RefButton.vue';
import AnswerButton from '@/components/App/AnswerButton/index.vue';

export default defineComponent({
	name: 'refs-share',

	components: {
		RefButton,
		AnswerButton
	},

	props: {
		buttons: {
			type: Array as PropType<Array<Button>>,
			required: true
		}
	},

	emits: ['click-button-with-payload', 'init'],

	computed: {
		refButtons(): Array<Button> {
			return this.buttons.filter((b) => b.params.type === 'refs_share');
		},

		continueButton(): Button {
			return this.buttons.filter((b) => b.params.type !== 'refs_share')[0];
		}
	},

	mounted() {
		this.$emit('init');
	},

	methods: {
		clickOnButton(button: Button) {
			if (button.link) {
				// Открываем окно с соц сетью в новом окне
				window.open(button.link, '', 'toolbar=0,status=0,width=626,height=436');
			}

			const text = button.command ?? button.text;
			const type = button.command ? 'command' : 'text-my';

			const payload = {
				text,
				textBody: button.text,
				params: button.params,
				type,

				buttonType: button.type
			};

			this.$emit('click-button-with-payload', payload);
		}
	}
});
